import 'lazysizes'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import JsCookie from 'js-cookie'
import './Icons/icons'
import { vNode } from './libs/vNode/vNode'

window.lazySizesConfig = { loadHidden: false }
window.Cookies = JsCookie
window.vNode = vNode
